export const STATUS_LABELS = {
  under_review: 'Under review',
  planned:      'Planned',
  maybe:        'Maybe',
  complete:     'Complete',
  closed:       'Closed'
}

export const STATUS_COLORS = {
  under_review: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-200',
  planned:      'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200',
  maybe:        'bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-200',
  complete:     'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-200',
  closed:       'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200'
}

export const CATEGORY_LABELS = {
  feature_request: 'Feature request',
  bug_report:      'Bug report'
}

export const CATEGORY_COLORS = {
  feature_request: 'bg-clcpurple/10 text-clcnavy-dark dark:text-clcpurple-light',
  bug_report:      'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200'
}

export const SORT_OPTIONS = [
  { value: 'newest',           label: 'Newest' },
  { value: 'most_voted',       label: 'Most voted' },
  { value: 'recently_updated', label: 'Recently updated' },
  { value: 'oldest',           label: 'Oldest' },
  { value: 'least_voted',      label: 'Least voted' }
]

export const formatDate = (iso) => {
  if (!iso) return ''
  try {
    const d = new Date(iso)
    return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })
  } catch (e) {
    return ''
  }
}
